/* eslint-disable */
import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import {
  FormProvider, SubmitHandler, useForm,
} from 'react-hook-form';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Typography,
  Button, Grid, Paper, IconButton, Card, Chip, Checkbox,
  Tooltip,
  CircularProgress,
} from '@mui/material';
import { IoMdAdd, IoMdRefresh } from "react-icons/io";
import * as yup from 'yup';
import { twMerge } from 'tailwind-merge';
import useYupValidationResolver from 'src/hooks/useYupValidationResolver';
import { FiPlusCircle } from 'react-icons/fi';
import { FaLinkedin, FaGithub, FaFacebook, FaTwitter, FaTelegram } from "react-icons/fa";
import { FaSquareArrowUpRight } from "react-icons/fa6";
import { AiOutlineLike, AiOutlineDislike } from "react-icons/ai";
import { IoTrashOutline } from 'react-icons/io5';
import { IoMdCloseCircleOutline } from "react-icons/io";
import { MdCancel } from "react-icons/md";
import { FcApproval } from "react-icons/fc";
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { ExpandUpIcon } from 'src/icons';
import { Loader } from 'src/components';
import Input from 'src/components/elements/Input';
import RHFInput from 'src/components/elements/Input/RHFInput';
import RHFSelect from 'src/components/elements/Select/RHFSelect';
import { Option } from 'src/components/elements/Select';
import RHFPhoneInput from 'src/components/elements/Input/RHFPhoneInput';
import RHFEditor from 'src/components/elements/Editor/RHFEditor';
import { DialogContentProps } from 'src/components/Dialog/Dialog';
import { JobType, PayType } from 'src/pages/CandidateInfo/types';
import RHFDOBInput from 'src/components/elements/Input/RHFDOBInput';
import { scrollToError } from 'src/utils/FormUtils';
import { ContactInfo, JDMatchScoreRequest, JDMatchScoreResponse, Vendor } from '../../types';
import API from '../../../../network';
import ResumeMatchAPI from '../../../../network/resumeMatchServices';
import RHFAutoComplete from 'src/components/elements/AutoComplete/RHFAutoComplete';
import { Option as CurrencyOption, options as currencyOptions } from 'src/components/elements/Input';
import { emailRegex, mobileRegExp } from 'src/utils/Regex';
import { confirmWrapper } from 'src/components/Dialog';
import { useVendors } from 'src/hooks/query/vendors';
import { AuthProvider } from '@panna/auth';
import AddAndRefreshConsultancyOptions from '../AddAndRefreshConsultancyOptions';
import Requests from 'src/network/accounts';
import { useLocations } from 'src/hooks/query/locations';
import { useJobTypes } from 'src/hooks/query/job-types';

interface CandidateDetailsFormProps extends DialogContentProps {
  onSave: (data: any, close: (() => void) | undefined) => Promise<void>;
  handleEmailDuplicate: (email: string, checkDuplicate: any, formData:CandidateDetailsFormValues, close: (() => void) | undefined) => void;
  onClose: () => void;
  resumeInfo: CandidateDetailsFormValues | null;
  payTypes: PayType[];
  workAuthorizations: string[];
  resumeSources: string[];
  jobDetails: any;
  fileName: string | null;
  useNewResume: boolean;
  updateResume: boolean;
}

export interface CandidateDetailsFormValues {
  firstName: string;
  lastName: string;
  candidateLocation: string;
  phoneNumber: string;
  candidateTitle: string;
  experienceLevel: string;
  emailAddress: string;
  alternateEmail: string;
  email?: string;
  payType: string;
  payRate: string;
  dateOfBirth: string;
  visaStatus: string;
  reLocation: string;
  resumeSource: string;
  consultancyId: string;
  consultancyContactId: string;
  consultancyPhoneNumber: string;
  extensionNumber: string;
  consultancyEmailAddress: string;
  comments: string;
  socialLinks: string;
  threshold: boolean;
  s3DownloadLink?: string;
  s3HtmlLink?: string;
  fileURL?: string;
  resumeHtmlUrl?: string;
}

const relocationOptions = [
  {label: 'YES', value: 'YES'},
  {label: 'NO', value: 'NO'},
]

const experienceOptions = [
  {label: 'Beginner (0-2 years)', value: 'Beginner (0-2 years)'},
  {label: 'Advanced (2-5 years)', value: 'Advanced (2-5 years)'},
  {label: 'Expert(5+ years)', value: 'Expert(5+ years)'},
];

const defaultCollapsibleSections = [{
  name: 'Basic Details',
  expanded: true,
},
{
  name: 'Additional Details',
  expanded: true,
},
{
  name: 'Consultancy Details',
  expanded: true,
},
{
  name: 'Comments',
  expanded: true,
}];

const CandidateDetailsForm = function CandidateDetailsForm(props: CandidateDetailsFormProps) {

  const {
    close,
    onSave,
    resumeInfo,
    payTypes,
    workAuthorizations,
    resumeSources,
    jobDetails,
    fileName,
    handleEmailDuplicate,
    useNewResume,
    onClose,
    updateResume,
  } = props;

  const [selectedCurrency, setSelectedCurrency] = useState<CurrencyOption>(currencyOptions[0]);
  const [socialLinks, setSocialLinks] = useState<string[]>([]);
  const [socialLinkInput, setSocialLinkInput] = useState<string>('');
  const [showSocialLink, setShowSocialLink] = useState<boolean>(false);
  const [collapsibleSections, setCollapsibleSections] = useState(defaultCollapsibleSections);
  const [resumeFileName, setResumeFileName] = useState<string | null>(null);
  const [thresholdVal, setThresholdVal] = useState(false);
  const [showThresholdError, setShowThresholdError] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [jdScoreData, setJDScoreData] = useState({
    skill_match: {
      jd_relevance_score: 0,
      matched: [''],
      matched_mandatory_skills_ratio: 0,
      skill_match_score: '',
      unmatched: [''],
    },
    jd_skill_frequency: {},
    resume_skill_frequency: {},
    jd_type_class: '',
    uid: '',
  });

  const [contactOptions, setContactoptions] = useState<Option<string, string>[]>([]);;
  const [consultancyContactInfo, setConsultancyContactInfo] = useState<ContactInfo[]>([]);

  const validationSchema = yup.object().shape({
    firstName: yup.string().typeError('Enter valid First name')
    .required('First Name is required'),
    lastName: yup.string().typeError('Enter valid Last name').required('Last Name is required'),
    // candidateLocation: resumeFileName ? yup.string().typeError('Enter valid Location')
    // .required('Location is required') : yup.string().typeError('Enter valid Location'),
    candidateLocation: yup.string().typeError('Enter valid Location'),
    resumeSource: yup.string().typeError('Enter valid source').required('Source is required'),
    phoneNumber: yup
    .string()
    .nullable()
    // .required('Contact number is required')
    .test(
      'isValidPhone',
      'Enter valid contact number',
      (value) => !value || value === '' || mobileRegExp.test(value)
    ),
    emailAddress: yup
    .string()
    .nullable()
    .required('Email address is required')
    .test(
      'isValidEmail',
      'Enter valid email address',
      (value) => !value || value === '' || emailRegex.test(value)
    ),
    alternateEmail: yup
    .string()
    .nullable()
    .notRequired()
    .test(
      'isValidEmail',
      'Enter a valid email address',
      (value) =>
        !value || value.trim() === '' || emailRegex.test(value)
    ),
    payType: yup.string().typeError('Enter Pay Type').notRequired(),
    payRate: yup.number().transform((value) => (isNaN(value) ? undefined : value)).typeError('Enter valid pay rate').nullable().notRequired(),
    visaStatus: yup.string().typeError('Enter valid Work authorization'),
    comments: resumeFileName 
    ? yup.string().typeError('Enter Valid Comments').required('Comments are required')
    :yup.string().typeError('Enter Valid Comments'),
    consultancyEmailAddress: yup
    .string()
    .email(),
    consultancyId: yup
    .string()
    .when(['payType'], (values, schema) => {
      const payTypeSelected = values[0];
      const matchingPayType = payTypesArray.find((payType) => payType.value === payTypeSelected);
      const isC2C = matchingPayType ? matchingPayType.label.toLowerCase().includes('c2c') : false;
      return isC2C
        ? schema.required('Consultancy Name required')
        : schema.notRequired();
    }),
    consultancyContactId: yup
    .string()
    .when(['payType'], (values, schema) => {
      const payTypeSelected = values[0];
      const matchingPayType = payTypesArray.find((payType) => payType.value === payTypeSelected);
      const isC2C = matchingPayType ? matchingPayType.label.toLowerCase().includes('c2c') : false;
      return isC2C
        ? schema.required('Consultancy Contact Person required')
        : schema.notRequired();
    }),
    consultancyPhoneNumber: yup
    .string(),
    extensionNumber: yup
    .string(),
  });

  const methods = useForm<CandidateDetailsFormValues>({
    defaultValues: {
      candidateTitle: '',
      payType: '',
      payRate: '',
      consultancyId: '',
      consultancyContactId: '',
      consultancyPhoneNumber: '',
      extensionNumber: '',
      consultancyEmailAddress: '',
      firstName: '',
      lastName: '',
      reLocation: '',
      candidateLocation: '',
      experienceLevel: '',
      emailAddress: '',
      alternateEmail: '',
      phoneNumber: '',
      dateOfBirth: '',
      visaStatus: '',
      resumeSource: '',
      comments: '',
      threshold: false,
    },
    resolver: useYupValidationResolver(validationSchema),
  });

  const {
    reset,
    handleSubmit,
    watch,
    setValue,
    clearErrors,
    formState: { errors },
    trigger,
  } = methods;

  const [saving, setSaving] = useState(false);

  const {fetchVendors, vendorOptions, vendorsLoading} = useVendors();

  const getConsultancyDetails = async () => {
    try {
      const consultancyId = watch("consultancyId");
      if (!consultancyId) {
        setValue('consultancyContactId', '');
        setValue("consultancyPhoneNumber", "");
        setValue("extensionNumber", "");
        setValue("consultancyEmailAddress", "");
        setContactoptions([]);
        return;
      }
      const res = await Requests.getInstance().getConsultancyById(consultancyId);
      const contactInfo = res.data.contactInfo;
      const contactOptions = contactInfo?.map((item: ContactInfo) => ({
        label: item.name,
        value: item.id?.toString() || '0',
      })) || [];
      setConsultancyContactInfo(contactInfo || []);
      setContactoptions(contactOptions);
      if (contactOptions.length === 1) {
        setValue('consultancyContactId', contactOptions[0].value);
        clearErrors('consultancyContactId');
      } else {
        setValue('consultancyContactId', '');
      }
    } catch (e) {
      console.info('error occured while fetching consultancyById', e);
    }
  }

  useEffect(() => {
    reset({
      candidateTitle: resumeInfo?.candidateTitle || '',
      payType: resumeInfo?.payType || '',
      payRate: resumeInfo?.payRate || '',
      consultancyId: resumeInfo?.consultancyId || '',
      consultancyContactId: resumeInfo?.consultancyContactId || '',
      consultancyPhoneNumber: resumeInfo?.consultancyPhoneNumber || '',
      extensionNumber: resumeInfo?.extensionNumber || '',
      consultancyEmailAddress: resumeInfo?.consultancyEmailAddress || '',
      firstName: resumeInfo?.firstName || '',
      lastName: resumeInfo?.lastName || '',
      reLocation: resumeInfo?.reLocation || '',
      candidateLocation: resumeInfo?.candidateLocation || '',
      experienceLevel: resumeInfo?.experienceLevel || '',
      emailAddress: resumeInfo?.email || resumeInfo?.emailAddress || '',
      alternateEmail: resumeInfo?.alternateEmail || '',
      phoneNumber: resumeInfo?.phoneNumber || '',
      dateOfBirth: resumeInfo?.dateOfBirth || '',
      visaStatus: resumeInfo?.visaStatus || '',
      resumeSource: resumeInfo?.resumeSource || '',
      comments: resumeInfo?.comments || '',
      fileURL: resumeInfo?.s3DownloadLink || resumeInfo?.fileURL,
      resumeHtmlUrl: resumeInfo?.s3HtmlLink || resumeInfo?.resumeHtmlUrl,
    });
     if (resumeInfo?.socialLinks && resumeInfo?.socialLinks !== '') {
       const links = resumeInfo?.socialLinks.split(',');
       setSocialLinks(links);
     }
     if (!useNewResume && resumeInfo?.email) {
       checkIfEmailDuplicate(resumeInfo?.email);
     }
    if ((resumeInfo?.s3DownloadLink && resumeInfo?.s3DownloadLink !== '') || (resumeInfo?.fileURL && resumeInfo?.fileURL !== '')) {
      getJDMatchScore();
     }
  }, [resumeInfo]);

  useEffect(() => {
    setResumeFileName(fileName);
  }, [fileName]);

  useEffect(() => {
    if (!vendorOptions?.length) fetchVendors();
  }, []);

  useEffect(() => {
    getConsultancyDetails();
  }, [watch("consultancyId")]);

  useEffect(()=>{
    const contactPersonNameId = watch("consultancyContactId");
    const contactPerson = consultancyContactInfo?.find((item)=>item?.id?.toString() === contactPersonNameId);
    setValue("consultancyPhoneNumber", contactPerson?.phoneNumber || "");
    setValue("extensionNumber", contactPerson?.extensionNumber || "");
    setValue("consultancyEmailAddress", contactPerson?.emailAddress || "");
  }, [watch("consultancyContactId"), consultancyContactInfo]);

  const getJDMatchScore = async () => {
    const request: JDMatchScoreRequest = {
      jobOrderId: jobDetails.jobOrderId,
      email: resumeInfo?.email || resumeInfo?.emailAddress || '',
      resume_url: resumeInfo?.s3DownloadLink || resumeInfo?.fileURL || '',
    };
    try {
      setFetching(true);
      const jdMatchScoreRes: JDMatchScoreResponse = await API.getInstance().jdMatchScore(request);
      setJDScoreData(jdMatchScoreRes);
    } catch (e) {
      console.log(e);
    } finally {
      setFetching(false);
    }
  };

  const submitHandler: SubmitHandler<CandidateDetailsFormValues> = async (data: CandidateDetailsFormValues) => {
    if (resumeFileName!==null && jdScoreData?.skill_match?.jd_relevance_score < 40 && !thresholdVal) {
      setShowThresholdError(true);
    } else {
      const requestObj = {
        payRate: data.payRate,
        payType: data.payType,
        middleName: '',
        candidateTitle: data.candidateTitle,
        consultancyId: data.consultancyId,
        consultancyContactId: data.consultancyContactId,
        consultancyPhoneNumber: data.consultancyPhoneNumber,
        extensionNumber: data.extensionNumber,
        consultancyEmailAddress: data.consultancyEmailAddress,
        firstName: data.firstName,
        lastName: data.lastName,
        reLocation: data.reLocation,
        candidateLocation: data.candidateLocation,
        experienceLevel: data.experienceLevel,
        emailAddress: data.emailAddress,
        alternateEmail: data.alternateEmail,
        phoneNumber: data.phoneNumber,
        dateOfBirth: data.dateOfBirth,
        visaStatus: data.visaStatus,
        resumeSource: data.resumeSource,
        comments: data.comments,
        socialLinks: socialLinks.toString(),
        currency:selectedCurrency.currencyName,
        // threshold: data.threshold,
        jdScore: jdScoreData?.skill_match?.jd_relevance_score,
        fileURL: resumeInfo?.s3DownloadLink || resumeInfo?.fileURL,
        resumeHtmlUrl: resumeInfo?.s3HtmlLink || resumeInfo?.resumeHtmlUrl,
      };
      setSaving(true);
      await onSave(requestObj, close);
      setSaving(false);
    }
  };

  const onCancel = () => {
    onClose && onClose();
    close && close();
  }

  const addSocialLink = () => {
    if (socialLinkInput.includes('.com')) {
      const formattedInput = socialLinkInput.toLowerCase().replace('www.', '');
      const linkInput = formattedInput.replace('.com', '');
      if (!resumeInfo?.socialLinks?.includes(linkInput)) {
        const updatedSocialLinks = [...socialLinks];
        updatedSocialLinks.push(socialLinkInput.toLowerCase());
        setSocialLinks(updatedSocialLinks);
        setSocialLinkInput('');
        setShowSocialLink(false);
      }
    }
  }

  const payTypesArray: Option<string, string>[] = payTypes.map((each) => ({
    label: each.name,
    value: (each.id).toString(),
  }));

  const {locationsOptions} = useLocations();

  const {jobTypesOptions} = useJobTypes();

  const sourcesArray: Option<string, string>[] = resumeSources.map((each) => ({
    label: each,
    value: each,
  }));

  const workAuthorizationsArray: Option<string, string>[] = workAuthorizations.map((each) => ({
    label: each,
    value: each,
  }));

  const handleAccordionChange = (name: string) => {
    const updatedData = collapsibleSections.map(each => {
      if (each.name === name) {
        return {
          ...each,
          expanded: !each.expanded,
        };
      }
      return each;
    });
    setCollapsibleSections(updatedData);
  };

  const getFormData = () => {
    const formData = methods.getValues();
    return {
      firstName: formData.firstName,
      lastName: formData.lastName,
      candidateLocation: formData.candidateLocation,
      phoneNumber: formData.phoneNumber,
      candidateTitle: formData.candidateTitle,
      experienceLevel: formData.experienceLevel,
      emailAddress: formData.emailAddress,
      alternateEmail: formData.alternateEmail,
      email: formData.email,
      payType: formData.payType,
      payRate: formData.payRate,
      dateOfBirth: formData.dateOfBirth,
      visaStatus: formData.visaStatus,
      reLocation: formData.reLocation,
      resumeSource: formData.resumeSource,
      consultancyId: formData.consultancyId,
      consultancyContactId: formData.consultancyContactId,
      consultancyPhoneNumber: formData.consultancyPhoneNumber,
      extensionNumber: formData.extensionNumber,
      consultancyEmailAddress: formData.consultancyEmailAddress,
      comments: formData.comments,
      socialLinks: formData.socialLinks,
      threshold: formData.threshold,
      fileURL: formData?.s3DownloadLink || formData?.fileURL,
      resumeHtmlUrl: formData?.s3HtmlLink || formData?.resumeHtmlUrl,
    };
  };

  const { emailAddress } = watch();

  const checkIfEmailDuplicate = async (emailAddress: string) => {
    try{
      const checkDuplicateResponse: any = await API.getInstance().checkEmailDuplicate(emailAddress);
      if(checkDuplicateResponse && checkDuplicateResponse.length > 0){
        const formData = getFormData();
        handleEmailDuplicate(emailAddress, checkDuplicateResponse, formData, close);
      }
    }catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    }
  }

  useEffect(() => {
    const isEmailValid = emailAddress && emailAddress.match(emailRegex);
    if(emailAddress && isEmailValid && !updateResume && !useNewResume && (!(!useNewResume && resumeInfo?.email) || (resumeInfo?.email !== emailAddress))){
      checkIfEmailDuplicate(emailAddress);
    }
  }, [emailAddress])
  

  const openSocialLink = (link: string) => {
    if (!link.includes('http')) {
      window.open('http://'+link, '_blank');
    } else {
      window.open(link, '_blank');
    }
  }

  const getIcon = (link: string) => {
    if (link?.toLowerCase().includes('linkedin.com')) {
      return <FaLinkedin color='blue' />
    } else if (link?.toLowerCase().includes('github.com')) {
      return <FaGithub color='purple' />
    } else if (link?.toLowerCase().includes('facebook.com')) {
      return <FaFacebook color='blue' />
    } else if (link?.toLowerCase().includes('telegram.com')) {
      return <FaTelegram color='blue' />
    } else if (link?.toLowerCase().includes('twitter.com')) {
      return <FaTwitter color='blue' />
    } else {
      return <FaSquareArrowUpRight />
    }
  }

  const deleteSkills = (skill: string, isMatched: boolean) => {
    let skillsArr: string [] = [];
    if (isMatched) {
      skillsArr = jdScoreData?.skill_match?.matched || [];
    } else {
      skillsArr = jdScoreData?.skill_match?.unmatched || [];
    }
    const updatedArr = skillsArr.filter(each => each !== skill);
    const updatedSkillMatchObj = {
      ...jdScoreData.skill_match,
      matched: isMatched ? updatedArr : jdScoreData.skill_match.matched,
      unmatched: isMatched ? jdScoreData.skill_match.unmatched : updatedArr,
    }
    setJDScoreData({
      ...jdScoreData,
      skill_match: updatedSkillMatchObj,
    });
  }

  const updateSkills = async () => {
    const { uid, jd_type_class, jd_skill_frequency, resume_skill_frequency, skill_match } =  jdScoreData;
    const { matched, unmatched } = skill_match; 
    const payload = {
      uid,
      resume_skill_frequency,
      jd_skill_frequency,
      jd_type_class,
      application: 'ats_api',
      matched,
      unmatched,
      skillSet: '',
    };
    setFetching(true);
    try {
      const response = await ResumeMatchAPI.getInstance().updateSkills(payload);
      setJDScoreData(response);
    } catch (e) {
      console.log(e);
    } finally {
      setFetching(false);
    }
  }

  const onError = () => {
    scrollToError('application-form');
  };

  return (
    <Paper id="application-form" className="p-4 rounded-md text-left" elevation={0}>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(submitHandler, onError)}>
          <div style={{ marginBottom: 8 }}>
            <div className="mt-2 mb-1 text-center">Apply to {jobDetails.jobId} - {jobDetails.jobTitle}</div>
            {
              resumeFileName &&
            <div className="mt-1 mb-8 text-center text-sm">Resume: {resumeFileName}</div>
            }
            {collapsibleSections.map(each => (
              <Accordion
              expanded={each.expanded}
              onChange={() => handleAccordionChange(each.name)}
              sx={{ mb: 1 }}
              >
                <AccordionSummary
                  expandIcon={<ExpandUpIcon />}
                  aria-controls="content"
                  id="content"
                >
                  <Typography>{each.name}</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ mb: 1 }}>
                  <>
                    {each.name === 'Basic Details' ? (
                      <div>
                        <Grid container spacing={3} mb={4} pl={3}>
                          <Grid item xs={12} sm={12} md={6} lg={4}>
                            <RHFInput control={methods.control} name="firstName" label="First Name" />
                          </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={4}>
                            <RHFInput control={methods.control} name="lastName" label="Last Name" />
                          </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={4}>
                            <div className="h-full relative -bottom-[27px]">
                              <RHFAutoComplete
                                control={methods.control}
                                name="candidateLocation"
                                label="Location"
                                options={locationsOptions}
                              />
                            </div>
                          </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={4}>
                            <RHFPhoneInput
                                control={methods.control}
                                name="phoneNumber"
                                label="Contact Number"
                              />
                          </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={4}>
                          <div className="h-full relative -bottom-[27px]">
                              <RHFAutoComplete
                                control={methods.control}
                                name="candidateTitle"
                                label="Candidate Job Title"
                                options={jobTypesOptions}
                              />
                          </div>
                          </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={4}>
                              <RHFSelect
                                control={methods.control}
                                name="experienceLevel"
                                label="Experience"
                                options={experienceOptions}
                              />
                          </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={4}>
                            <RHFInput
                              control={methods.control}
                              name="emailAddress"
                              label="Email Address"
                              disabled={updateResume || useNewResume}
                            />
                          </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={4}>
                            <RHFInput
                              control={methods.control}
                              name="alternateEmail"
                              label="Alternate Email Address"
                              disabled={updateResume || useNewResume}
                            />
                          </Grid>
                        </Grid>
                        <Box className="flex gap-2 flex-wrap">
                          {socialLinks && socialLinks.length > 0 && socialLinks.map((each) => {
                            return (
                              <Box className="relative">
                                <Tooltip title={each}>
                                  <IconButton
                                    onClick={() => openSocialLink(each)}
                                    >
                                    {getIcon(each)}
                                  </IconButton>
                                </Tooltip>
                                <IconButton
                                  className="absolute -top-3 -right-4 hover:text-error"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSocialLinks(socialLinks.filter((link) => link !== each));
                                  }}
                                >
                                  <IoMdCloseCircleOutline
                                    size={14}
                                  />
                                </IconButton>
                              </Box>
                            )
                          })}
                        </Box>
                        <div className="pl-5 mt-2 pt-0 mb-2">
                          <Button
                            variant="text"
                            startIcon={<FiPlusCircle />}
                            onClick={() => setShowSocialLink(true)}
                          >
                            Add Social Link
                          </Button>
                        </div>
                        {showSocialLink && (
                          <Grid container spacing={3} mb={4} pl={3}>
                            <Grid item xs={12} sm={12} md={6} lg={4}>
                              <Input
                                value={socialLinkInput}
                                onChange={(event: any) => {
                                  setSocialLinkInput(event)
                                }}
                              />
                            </Grid>
                            <Grid display="flex" sx={{ mt: 3 }}>
                              <IconButton
                                onClick={addSocialLink}
                              >
                                <FcApproval color='#F97171' />
                              </IconButton>
                              <IconButton 
                                onClick={() => {
                                  setShowSocialLink(false);
                                  setSocialLinkInput('');
                                }}
                              >
                                <MdCancel color='red' />
                              </IconButton>
                            </Grid>
                          </Grid>
                        )}
                      </div>
                    ) :  each.name === 'Additional Details' ? (
                      <Grid container spacing={3} mb={4} pl={3}>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                          <div className="h-full flex items-start">
                            <RHFSelect
                              control={methods.control}
                              name="payType"
                              label="Pay Type"
                              options={payTypesArray}
                            />
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                          <RHFInput name="payRate" iconStart="$" control={methods.control} label="Pay Rate" onCurrencyChange={(currency: CurrencyOption) => setSelectedCurrency(currency)} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                          <RHFDOBInput control={methods.control} name="dateOfBirth" label="D.O.B (mm/dd)" />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                          <div className="h-full flex items-start">
                            <RHFSelect
                              control={methods.control}
                              name="visaStatus"
                              label="Work Authorization"
                              options={workAuthorizationsArray}
                            />
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                          <div className="h-full flex items-start">
                            <RHFSelect
                              control={methods.control}
                              name="reLocation"
                              label="Relocation"
                              options={relocationOptions}
                            />
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                          <div className="h-full flex items-start">
                            <RHFSelect
                              control={methods.control}
                              name="resumeSource"
                              label="Source"
                              options={sourcesArray}
                            />
                          </div>
                        </Grid>
                      </Grid>
                    ) : each.name === 'Consultancy Details' ? (
                      <div>
                      <Grid container spacing={3} mb={4} pl={3} justify-content='flex-start'>
                        <Grid item xs={12} sm={12} md={12} lg={8}>
                          <div className="h-full relative -bottom-[25px] flex items-start mb-8">
                            <RHFAutoComplete control={methods.control} name="consultancyId" label="Consultancy Name" options={vendorOptions} loading={vendorsLoading} />
                            <AuthProvider>
                              <AddAndRefreshConsultancyOptions fetchVendors={fetchVendors} />
                            </AuthProvider>
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                          <div className="h-full relative -bottom-[25px]">
                            <RHFAutoComplete control={methods.control} name="consultancyContactId" label="Contact Person" options={contactOptions} loading={vendorsLoading} />
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                          <RHFPhoneInput
                            control={methods.control}
                            name="consultancyPhoneNumber"
                            label="Contact Number"
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={2}>
                          <RHFInput
                            control={methods.control}
                            name="extensionNumber"
                            label="Ext No."
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                          <RHFInput control={methods.control} name="consultancyEmailAddress" label="Email Address" disabled />
                        </Grid>
                      </Grid>
                    </div>
                    ) : (
                        <RHFEditor
                        editorType="classic"
                        name="comments"
                        control={methods.control}
                        disabled={false}
                        height={250}
                      />
                    )}
                  </>
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
          {
            resumeFileName && 
            <>
            <Card sx={{ pl: 2, pr:2, mb: 2 }}>
            <div className='flex flex-row justify-between'>     
              <div className="text-[16px] relative mb-6 mt-4">
                Resume to JD Match Score
              </div>
              <div className="relative mb-6 mt-4 flex flex-row justify-between w-[50px]">
                <AiOutlineLike className='w-[20px] h-[20px]'/>
                <AiOutlineDislike className='w-[20px] h-[20px]' />
              </div>
            </div>
            {fetching ? (
              <div className="z-10">
                <Loader text='Fetching JD Match Score' />
              </div>
              ) : (
                <div>
                  <div className='flex justify-center mb-[20px]'>
                    <div className='flex flex-row w-[40%] items-center'>
                      <div style={{ width: 80, height: 80 }}>
                        <CircularProgressbar value={jdScoreData?.skill_match?.jd_relevance_score} text={`${jdScoreData?.skill_match?.jd_relevance_score}%`}/>
                      </div>
                      <div className='ml-8'>Relevance Score</div>
                    </div>
                  </div>
                  <div className='mb-6 text-[#228B22] font-semibold text-[1rem]'>
                    Matched Skills ({jdScoreData?.skill_match?.matched?.length})
                  </div>
                  <div className="w-[100%] flex mb-[20px] flex-wrap">
                    {jdScoreData?.skill_match?.matched?.length > 0 ? (jdScoreData?.skill_match?.matched).map((each: string) => (
                      <div className="flex flex-row items-center">
                        <Chip
                          label={each}
                          onDelete={() => deleteSkills(each, true)}
                          deleteIcon={<IoTrashOutline />}
                          sx={{ marginRight: '10px', marginBottom: '10px' }}
                        />
                      </div>
                    )) : null}
                  </div>
                  <div className='mb-6 text-[#C70039] font-semibold text-[1rem]'>
                    Unmatched Skills ({jdScoreData?.skill_match?.unmatched?.length})
                  </div>
                  <div className="w-[100%] flex mb-[20px] flex-wrap">
                    {jdScoreData?.skill_match?.unmatched?.length > 0 ? (jdScoreData?.skill_match?.unmatched).map((each: string) => (
                      <div className="flex flex-row items-center">
                        <Chip
                          label={each}
                          onDelete={() => deleteSkills(each, false)}
                          deleteIcon={<IoTrashOutline />}
                          sx={{ marginRight: '10px', marginBottom: '10px' }}
                        />
                      </div>
                    )) : null}
                  </div>
                  <div className='flex justify-end'>
                    <Button
                      variant="contained"
                      size="large"
                      sx={{ marginTop: '10px', marginBottom: '20px'}}
                      onClick={updateSkills}
                    >
                      Update Skills
                    </Button>
                  </div>
                </div>
            )}
          </Card>
          {!fetching && jdScoreData?.skill_match?.jd_relevance_score < 40 ? (
            <Card sx={{ pl: 2, pr:2, pt:3, pb:3, mb: 2 }}
              className={twMerge(showThresholdError && 'outline outline-[1px] outline-error')}
            >
              <div className='flex flex-row justify-between'>     
                <Checkbox
                  checked={thresholdVal}
                  size="medium"
                  className="p-0 pr-4"
                  onChange={(e) => {
                    setThresholdVal(e.target.checked);
                    if (e.target.checked) {
                      setShowThresholdError(false);
                    }
                  }}
                />
                <span className='ml-2'>
                  The score is below the threshold score of 40%. If you still want to apply, then please select check box and proceed further
                </span>
              </div>
            </Card>
          ) : null}
            </>
          }
          <Grid item md={12} gap={2} className="mt-2 flex justify-center">
            <Button
              variant="contained"
              size="large"
              type="submit"
              sx={{ marginTop: '10px'}}
              disabled={saving}
              startIcon={saving ? <CircularProgress size={16} className="text-black" /> : null}
            >
              {saving? "Saving..." : "Save and Apply"}
              
            </Button>
            <Button
              variant="outlined"
              size="large"
              sx={{ marginTop: '10px'}}
              onClick={onCancel}
              disabled={saving}
            >
              Cancel
            </Button>
          </Grid>
        </form>
      </FormProvider>
    </Paper>
  );
};

export default CandidateDetailsForm;
